import { PricingGroup } from "./PricingGroup";
import { PurchaseRule } from "./PurchaseRule";

export interface PriceVariation {
    name: string;
    type: PriceVariationType;
    pricingGroups: PricingGroup[];
    linkedPurchaseRules?: PurchaseRule[];
}

export enum PriceVariationType {
    BASE = "base",
    ADJUSTMENT = "adjustment",
}
